<template>
  <div
    class="relative"
    :class="{
      'drv-gap': drvActive,
      'app-gap': appActive,
      'both-type': bothActive,
      'drv-round-gap': roundvActive,
    }"
  >
    <!--<div class="btn-resource-add d-flex justify-end">-->
    <div class="btn-resource-add">
      <v-btn
        large
        depressed
        max-height="32px"
        color="#fecd06"
        class="button-type-1"
        @click="appendResource"
      >
        <v-icon left> mdi-plus </v-icon>
        동영상 소재추가
      </v-btn>
    </div>

    <div
      class="resource-cont relative white rounded pa-6 pr-16 pb-8"
      v-for="(resource, i) in this.resources"
      :key="i"
    >
      <!-- resource-box -->
      <div class="resource-box relative">
        <!-- 소재명 -->
        <v-form v-model="valid[i]">
          <div class="form-row-1">
            <p class="label">
              소재명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <div class="">
                <v-text-field
                  v-model="resource.name"
                  label="첨부할 영상 소재명을 입력해주세요. (한글/영문 20자이내)"
                  class="input-custom-2"
                  height="40px"
                  solo
                  :rules="subjectTitleRules"
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-form>
        <!-- //소재명 -->
        <!-- 예약설정 -->
        <div class="form-row-1 mb-8">
          <p class="label">
            예약설정
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="datepicker-type-1">
              <v-icon>mdi-calendar-blank</v-icon>
              <date-range-picker
                ref="picker"
                v-model="resource.dateRange"
                :date-format="dateFormat"
                :locale-data="localeData"
                :ranges="false"
                :time-picker="true"
                :time-picker-seconds="true"
                :time-picker-increment="1"
                opens="right"
                @update="updateDateRange(resource)"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.startDate | moment('YYYY.MM.DD HH:mm:ss') }}
                  <span class="ml-3 mr-3"> ~ </span>
                  {{ picker.endDate | moment('YYYY.MM.DD HH:mm:ss') }}
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
        <!--// 예약설정 -->
        <!-- 파일업로드 -->
        <div class="form-row-1 mb-8" style="border: 1p solid blue">
          <p class="label">
            파일첨부
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="d-flex">
              <!-- 파일첨부 -->
              <div class="file-upload-box-2">
                <!-- reource에 파일이 있으면 보이도록 -->
                <div v-if="resource.file">
                  <div v-if="!file[i].thumb" class="file-thumb">
                    <video width="84" height="84" controls>
                      <source :src="resource.file" type="video/x-ms-wmv" />
                      <source :src="resource.file" type="video/webm" />
                      <source :src="resource.file" type="video/mp4" />
                    </video>
                  </div>
                  <div v-else class="file-thumb">
                    <video width="84" height="84" controls>
                      <source :src="file[i].thumb" type="video/x-ms-wmv" />
                      <source :src="file[i].thumb" type="video/webm" />
                      <source :src="file[i].thumb" type="video/mp4" />
                    </video>
                  </div>
                </div>
                <!-- reource에 파일이 없고 등록할 때 보이도록 -->
                <div v-else class="file-thumb">
                  <div v-if="file[i].thumb">
                    <video width="84" height="84" controls>
                      <source :src="file[i].thumb" type="video/x-ms-wmv" />
                      <source :src="file[i].thumb" type="video/webm" />
                      <source :src="file[i].thumb" type="video/mp4" />
                    </video>
                  </div>
                  <v-icon v-else>mdi-image-outline</v-icon>
                </div>

                <div class="file-text">
                  <div class="d-flex">
                    <div class="file-wrap">
                      <v-btn
                        large
                        depressed
                        max-height="32px"
                        color="#fecd06"
                        class="button-type-1"
                        type="file"
                      >
                        파일 업로드
                      </v-btn>
                      <input
                        type="file"
                        @change="onFileChange($event, i)"
                        accept="video/x-ms-wmv,video/webm,video/mp4"
                        :id="`fileUploader${i}`"
                      />
                    </div>
                  </div>
                  <p class="form-coment-1 my-1 mt-3">
                    <v-icon>mdi-alert-circle-outline</v-icon>
                    .WMV 영상 길이는 15초 / 30초 두가지 제공 / 소재별 노출
                    시점을 지정할 수 있으며, 소재변경이 예정된 경우 예약
                    스케줄링을 통해 등록해 둘 수 있다.
                  </p>
                  <div v-if="!resource.file">
                    <div v-if="file[i].thumb">
                      <p class="file-name mb-0 mt-1" v-if="file.name">
                        {{ file[i].name }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //파일업로드 -->
        <!-- 영상해시 -->
        <div class="form-row-1">
          <p class="label">
            영상해시
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <v-text-field
              v-model="resource.hash"
              label="영상별 해시코드를 입력해주세요."
              class="input-custom-2"
              height="40px"
              solo
            ></v-text-field>
          </div>
        </div>
        <!-- //영상해시 -->
        <!-- 소재삭제버튼 -->
        <a
          href="javascript:void(0);"
          class="btn-ico-delete"
          @click="openRemoveConfirmPopup(resource, i)"
        >
          <v-icon>mdi-delete</v-icon>
        </a>
        <!--// 소재삭제버튼 -->
        <!-- 소재저장 버튼-->
        <div class="d-flex justify-center">
          <div v-if="!resource.id">
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !resource.hash || !file[i].thumb"
              @click.prevent="saveResources(resource)"
            >
              저장
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !resource.hash"
              @click="updateResources(resource)"
            >
              수정
            </v-btn>
          </div>
        </div>
        <!-- //소재저장 버튼 -->
      </div>
      <!-- //resource-box -->
    </div>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="removeResource"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { addResource, updateResource, deleteResource } from '@/api/campaign';
import { uploadImgPermissions, uploadFile, createUploadForm } from '@/api/etc';
import { toISOFormattedDate } from '@/utils/validation';
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {
    DateRangePicker,
    SystemAlert,
  },
  props: {
    propsInventoryType: String,
    propsInventoryId: String,
    propsInventory: Object,
    propsLineItemId: String,
    propsLriId: String,
    propsResources: Array,
    propsAdvertiserId: String,
    propsResourceType: String,
  },

  data: () => ({
    valid: [false],
    subjectTitleRules: [
      v => !!v || '소재명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문 20자 이내로 입력해주세요.',
      v => (v && v.length <= 20) || '한글/영문 20자 이내로 입력해주세요.',
    ],
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    file: [
      {
        img: null,
        name: null,
        thumb: null,
        type: 1,
      },
    ],

    fileCnt: 1,
    fileCategory: 'video',
    permissionInfo: {},
    preFilePath: '',

    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      name: '',
      start_at: null,
      end_at: null,
      is_valid: 'Y',
      type: 0,
      hash: '',
      file: '',
    },
    showSystemAlert: false,
    confirmSystemAlert: false,
    logResult: '',
    editItem: {},
    editItemIndex: null,
  }),
  computed: {
    resources: {
      get() {
        (this.propsResources || []).map(resource => {
          let obj = {
            startDate: resource.start_at,
            endDate: resource.end_at,
          };
          resource.dateRange = obj;
        });

        return this.propsResources;
      },
      set(value) {
        this.propsResources = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
    drvActive() {
      return this.propsInventoryType == 'drv';
    },
    appActive() {
      return this.propsInventoryType == 'app';
    },
    bothActive() {
      return this.propsResourceType == 'both';
    },
    roundvActive() {
      return this.propsInventoryType == 'roundv';
    },
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.propsInventory.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.propsInventory.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    onFileChange(e, i) {
      const targetFile = e.target.files[0];
      if (
        targetFile.type === 'video/x-ms-wmv' ||
        targetFile.type === 'video/webm' ||
        targetFile.type === 'video/mp4'
      ) {
        this.file[i].name = targetFile.name;
        this.file[i].thumb = URL.createObjectURL(targetFile);
        this.file[i].img = targetFile;
        this.file[i].type = 1;
        this.fileCategory =
          targetFile.type === 'video/x-ms-wmv'
            ? 'wmv'
            : targetFile.type === 'video/webm'
            ? 'webm'
            : 'mp4';

        this.permissionsImg(i);
      } else {
        this.showSystemAlert = true;
        this.logResult = 'WMV, WEBM, MP4 형식만 사용 가능 합니다.';
      }
      //동일 파일 연속 선택 시, change 이벤트가 발생되지 않도록 추가.
      document.getElementById(`fileUploader${i}`).value = '';
    },
    async permissionsImg(i) {
      try {
        const params = {
          cnt: this.fileCnt,
          category: this.fileCategory,
        };
        const { data } = await uploadImgPermissions({ params });
        this.permissionInfo = data.list[0];
        await this.savefileUpload(i);
      } catch (error) {
        console.log(error.response);
      }
    },
    savefileUpload(i) {
      let url = this.permissionInfo.domain;
      this.preFilePath = this.permissionInfo.uploadImagePath;
      const formData = createUploadForm(this.permissionInfo, this.file[i].img);

      this.uploadComplete(url, formData);
    },
    async uploadComplete(url, formData) {
      try {
        await uploadFile(url, formData);
        this.$forceUpdate();
      } catch (error) {
        console.log(error.response);
      }
    },

    setDetailResourceIfEmpty() {
      if (this.resources.length === 0) {
        this.defaultResource.dateRange.startDate = this.defaultStartAt;
        this.defaultResource.dateRange.endDate = this.defaultEndAt;
        this.defaultResource.start_at = this.defaultStartAt;
        this.defaultResource.end_at = this.defaultEndAt;
        this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
      }
    },

    async saveResources(resource) {
      if (!this.propsLriId) {
        this.showSystemAlert = true;
        this.logResult = '그룹코드를 선택 해주세요';
      } else {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;

        resource.start_at = toISOFormattedDate(new Date(resource.start_at));
        resource.end_at = toISOFormattedDate(new Date(resource.end_at));
        resource.file = this.preFilePath;
        resource.name = resource.name.trim();

        try {
          const { data } = await addResource(
            campaignId,
            inventoryId,
            lineItemId,
            lriId,
            resource,
          );
          if (data.result === 'success') {
            this.logResult = '저장되었습니다.';
            this.showSystemAlert = true;
            const emitData = {
              resourceId: data.value,
              lriId: this.propsLriId,
              resourceType: 0,
            };
            this.$emit('getResourceAfterAdd', emitData);
          }
        } catch (error) {
          console.log(error.response);
          const { data } = error.response;
          if (data.result === 'OutRange') {
            this.showSystemAlert = true;
            this.logResult =
              '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
          } else if (data.result === 'IsAlreadyReserved') {
            this.showSystemAlert = true;
            this.logResult = '선택된 지면은 현재 집행중인 캠페인이 있습니다.';
          } else {
            return false;
          }
        }
      }
    },

    async updateResources(resource) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.propsLineItemId;
      const lriId = this.propsLriId;
      const resourceId = resource.id;

      let updateResourceFile = '';
      if (this.preFilePath && resource.file !== this.preFilePath) {
        updateResourceFile = this.preFilePath;
      } else {
        updateResourceFile = resource.file;
      }

      const resourceData = {
        type: 0,
        name: resource.name.trim(),
        start_at: toISOFormattedDate(new Date(resource.start_at)),
        end_at: toISOFormattedDate(new Date(resource.end_at)),
        file: updateResourceFile,
        hash: resource.hash,
      };

      try {
        const { data } = await updateResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
          resourceData,
        );

        if (data.result === 'success') {
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 0,
          };
          this.$emit('getResourceAfterAdd', emitData);
          this.logResult = '수정되었습니다.';
          this.showSystemAlert = true;
        }
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult =
            '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
        }
      }
    },

    updateDateRange(resource) {
      resource.start_at = resource.dateRange.startDate;
      resource.end_at = resource.dateRange.endDate;
    },
    openRemoveConfirmPopup(item, i) {
      if (!item.id) {
        if (this.resources.length > 1) {
          this.resources.splice(i, 1);
          this.valid.splice(i, 1);
        } else {
          return false;
        }
      } else {
        this.editItem = item;
        this.editItemIndex = i;
        this.logResult = '정말로 삭제하시겠습니까?';
        this.confirmSystemAlert = true;
      }
    },
    async removeResource() {
      bus.$emit('start:spinner');
      this.confirmSystemAlert = false;
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;
        const resourceId = this.editItem.id;
        const { data } = await deleteResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
        );

        if (data.result === 'success') {
          //validation check 순번 삭제
          this.valid.splice(this.editItemIndex, 1);
          //this.file.splice(this.editItemIndex, 1);
          this.file[this.editItemIndex].name = null;
          this.file[this.editItemIndex].thumb = null;
          this.file[this.editItemIndex].img = null;
          this.file[this.editItemIndex].type = 1;

          this.logResult = '삭제되었습니다.';
          this.showSystemAlert = true;
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 0,
          };
          this.$emit('getResourceAfterDelete', emitData);
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    appendResource() {
      //validate check 추가
      this.valid.push(false);

      this.file.push({
        img: null,
        name: null,
        thumb: null,
        type: 1,
      });
      this.defaultResource.dateRange.startDate = this.defaultStartAt;
      this.defaultResource.dateRange.endDate = this.defaultEndAt;
      this.defaultResource.start_at = this.defaultStartAt;
      this.defaultResource.end_at = this.defaultEndAt;
      this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
    },
  },
  created() {
    this.setDetailResourceIfEmpty();
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
  mounted() {},
  beforeUpdate() {
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.both-type {
  .resource-cont {
    padding-top: 0 !important;
  }
  .btn-resource-add {
    margin-top: 0 !important;
    padding-top: 0px !important;
    padding-bottom: 0 !important;
    position: absolute;
    top: -128px;
    right: 0;
    z-index: 1;
  }
}
.resource-cont {
  margin-top: 12px;
}
.btn-resource-add {
  position: absolute;
  right: 0;
  top: -44px;
}
</style>
